<template>
  <div class="celebration-container">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600" width="100%" height="100%">
      <!-- Background Gradient -->
      <defs>
        <linearGradient id="backgroundGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fa709a" />
          <stop offset="100%" stop-color="#fee140" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#backgroundGradient)" />
      
      <!-- Confetti (Callout Wishes) -->
      <g v-for="wish in wishes" :key="wish.id" class="wish" :transform="'translate(' + wish.x + ',' + wish.y + ') rotate(' + wish.rotation + ')'" >
        <g fill="none" stroke="#fff" stroke-width="2">
          <path d="M0 0 L0 -40 L40 -40 L40 -60 L60 -40 L80 -40 L80 0 Z" fill="#fff" />
          <path d="M0 0 L0 -40 L40 -40 L40 -60 L60 -40 L80 -40 L80 0 Z" />
        </g>
        <animate attributeName="opacity" :values="wish.visible ? '0;1;0' : '1;0;1'" dur="4s" repeatCount="indefinite" />
      </g>
      
      <!-- Celebration Text (Small Fonts) -->
      <text v-for="(message, index) in displayedMessages" :key="index" :x="30" :y="30 + index * 20" text-anchor="start" font-size="14" fill="#fff" font-family="'Arial', sans-serif">
        {{ message }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wishes: [],
      messages: ['Congratulations!', 'Well done!', 'Great job!', 'Keep it up!', 'You did it!'],
      fonts: ['Arial', 'Verdana', 'Helvetica', 'Georgia', 'Times New Roman', 'Courier New'],
      displayedMessages: []
    };
  },
  mounted() {
    this.generateWishes();
    this.updateDisplayedMessages();
  },
  methods: {
    generateWishes() {
      for (let i = 0; i < 20; i++) {
        const randomFontIndex = Math.floor(Math.random() * this.fonts.length);
        this.wishes.push({
          id: i,
          x: Math.random() * 800,
          y: Math.random() * 600,
          rotation: Math.random() * 360,
          visible: false,
          delay: i * 0.5 // Adding delay for staggered animation
        });
      }
      // Start the animation after wishes are generated
      this.startAnimation();
    },
    startAnimation() {
      this.wishes.forEach((wish, index) => {
        setTimeout(() => {
          this.$set(this.wishes, index, { ...wish, visible: true });
        }, wish.delay * 1000); // Convert seconds to milliseconds
      });
    },
    updateDisplayedMessages() {
      // Randomly select 5 messages
      const shuffledMessages = this.messages.sort(() => Math.random() - 0.5);
      this.displayedMessages = shuffledMessages.slice(0, 5);
    }
  }
};
</script>

<style scoped>
.celebration-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.wish {
  cursor: pointer;
}
</style>
